import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "renova360_token";

export function getToken() {
    try {
        return localStorage.getItem(TOKEN_KEY);
    } catch {
        return null;
    }
}

export function setToken(token) {
    try {
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
    } catch {
        /* ignore */
    }
}

export const api = axios.create({ baseURL: API, timeout: 120000 });

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export function formatApiError(err) {
    // 1) detail strutturato dal backend (FastAPI HTTPException)
    const detail = err?.response?.data?.detail;
    if (detail) {
        if (typeof detail === "string") return detail;
        if (Array.isArray(detail))
            return detail
                .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
                .filter(Boolean)
                .join(" ");
        if (detail && typeof detail.msg === "string") return detail.msg;
        return String(detail);
    }

    // 2) Risposta HTTP senza detail (es. 502/504 dal proxy K8s o 413 ingress)
    const status = err?.response?.status;
    if (status === 401) return "Sessione scaduta. Ricarica la pagina e accedi di nuovo.";
    if (status === 402) return "Credito AI esaurito. Vai su Profilo → Universal Key → Add Balance per ricaricare.";
    if (status === 403) return "Operazione non permessa con il tuo piano corrente.";
    if (status === 413) return "File troppo grande. Comprimi il PDF o caricalo in più parti (max 25 MB per chiamata in produzione).";
    if (status === 429) return "Troppe richieste in poco tempo. Attendi qualche secondo e riprova.";
    if (status === 502) return "Backend temporaneamente non disponibile. Riprova fra qualche secondo.";
    if (status === 503) return "Servizio temporaneamente sovraccarico. Riprova fra qualche minuto.";
    if (status === 504) return "Timeout del server. L'operazione richiede troppo tempo: prova con un file più piccolo o usa un job in background.";

    // 3) Errore senza response (network, CORS, DNS, timeout client)
    const code = err?.code;
    if (code === "ECONNABORTED") return "Timeout della connessione. La risposta del server ha impiegato troppo tempo. Riprova o usa un file più piccolo.";
    if (code === "ERR_NETWORK") return "Errore di rete. Verifica la connessione internet o ricarica la pagina. Se il problema persiste, il server potrebbe essere in deploy.";

    // 4) Fallback
    return err?.message || "Errore inatteso.";
}
